<template>
    <div v-if="visible" class="page-loading-bar" :class="phase" />
</template>

<script setup>
import { ref, watch } from 'vue';
import { usePageLoading } from '@/composables/usePageLoading.js';

const { loading } = usePageLoading();

const visible = ref(false);
const phase = ref('');
let hideTimer = null;

watch(loading, (val) => {
    clearTimeout(hideTimer);
    if (val) {
        visible.value = true;
        // Next tick so the DOM is painted at width:0 before the transition kicks in
        requestAnimationFrame(() => {
            phase.value = 'running';
        });
    } else {
        phase.value = 'done';
        hideTimer = setTimeout(() => {
            visible.value = false;
            phase.value = '';
        }, 400);
    }
});
</script>

<style scoped>
.page-loading-bar {
    position: fixed;
    top: 0;
    left: 0;
    height: 2px;
    width: 0%;
    z-index: 9999;
    background: linear-gradient(90deg, #0A531E, #16a34a, #4ade80);
    border-radius: 0 2px 2px 0;
    pointer-events: none;
}

.page-loading-bar.running {
    width: 75%;
    transition: width 2s cubic-bezier(0.1, 0.5, 0.5, 1);
}

.page-loading-bar.done {
    width: 100%;
    transition: width 0.2s ease-in, opacity 0.2s ease 0.2s;
    opacity: 0;
}
</style>
